<template>
  <div>
    <div
      v-click-outside="$_dropdownClose"
      class="remind-tool"
    >
      <i
        class="remind-tool_icon"
        :class="[icon,{remind:isNotice,active:isActived}]"
        @click="$_onClick()"
      />
      <transition mode="out-in">
        <div
          v-if="isActived"
          class="remind-tool_content"
        >
          <div class="remind-tool_content__top">
            <div class="remind-tool_content__top__text">
              {{ $t('通知中心') }}
            </div>
            <div
              class="remind-tool_content__top__btn"
              @click="$_onRemindPageClock()"
            >
              <i class="icon-arrow-right" />
            </div>
          </div>
          <perfect-scrollbar
            v-scroll:throttle="{fn: $_onScroll, throttle: 32 }"
            class="ps remind-tool_scroll-content"
            :class="{empty:itemList.length === 0}"
          >
            <div
              v-if="itemList.length === 0 && !isLoading"
              class="scroll-content_empty-content"
            >
              <i
                class="empty-icon"
                :class="emptyIcon"
              />
              <p class="empty-text">
                {{ emptyText }}
              </p>
            </div>
            <div
              v-else
              class="scroll-content_item-list"
            >
              <DotRemindContent
                v-for="(item,itemIndex) in itemList"
                :key="itemIndex"
                :data="item"
                @remind-click="$_remindClick(item)"
              />
            </div>
            <DotLoading v-if="isLoading" />
          </perfect-scrollbar>
          <div
            class="remind-tool_content__bottom"
            @click="$_onAllRemindRead()"
          >
            {{ $t('全部標示為已讀') }}
          </div>
          <div
            class="remind-tool_content__bottom"
            @click="$_onRemindPageClock()"
          >
            {{ $t('查看更早的通知') }}
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import notificationService from "@/service/api/v1/notification";
import ClickOutside from "vue-click-outside";
export default {
  name: "RemindTool",
  directives: {
    ClickOutside,
  },
  props: {
    icon: {
      type: String,
      default: "icon-nav-alert-outline",
    },
    emptyIcon: {
      type: String,
      default: "icon-nav-alert-outline",
    },
    emptyText: {
      type: String,
      default() {
        return this.$t("目前沒有通知");
      },
    },
    isNotice: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    isLoading: false,
    isActived: false,
    itemList: [],
    page: 1,
    lastPage: 0,
    scrollTotalHeight: 0,
    windowTotalHeight: 0,
    position: {},
  }),
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
  },
  methods: {
    async $_onClick() {
      this.isActived = !this.isActived;
      if (this.isActived) {
        this.page = 1;
        this.itemList = [];
        await this.$_fetchData();
      }
    },
    $_dropdownClose() {
      this.isActived = false;
    },
    $_remindClick(item) {
      this.$emit("remind-click", item);
    },
    $_onRemindPageClock() {
      this.$router.push(`/factory/${this._currentFactoryId}/notifications`);
      this.isActived = false;
    },
    async $_onScroll(e, position) {
      this.scrollTotalHeight = e.target.scrollHeight;
      this.windowTotalHeight = e.target.offsetHeight;
      this.position = position;
      await this.$_scrollBottomGetDropdown();
    },
    async $_scrollBottomGetDropdown() {
      const allScrollHeight = this.scrollTotalHeight - this.windowTotalHeight;
      const scrollHeight = this.position.scrollTop;
      if (scrollHeight / allScrollHeight > 0.95 && !this.isLoading) {
        if (this.page < this.lastPage) {
          this.page += 1;
          await this.$_fetchData();
        }
      }
    },
    async $_fetchData() {
      if (this.page === this.lastPage) return;
      try {
        this.isLoading = true;
        if (this.page < this.lastPage) {
          this.page++;
        }
        const params = {
          ...this.params,
          page: this.page,
          order_way: "desc",
          order_by: "created_at",
        };
        const res = await notificationService.index(params);
        this.itemList = [...this.itemList, ...res.data];
        if (res.meta && res.meta.last_page) {
          this.lastPage = res.meta.last_page;
        }
        this.isLoading = false;
      } catch {
        alert("remind tool error");
      }
    },
    async $_onAllRemindRead() {
      try {
        await notificationService.readAll();
        const _currentUser = {...this.$store.state.stone_auth.currentUser}
        _currentUser.unread_notification_count = 0
        this.$store.dispatch("stone_auth/setCurrentUser",_currentUser)
        this.$_fetchData()
      } catch(error) {
        alert(error)
      }
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/remind-tool";
</style>